import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, } from 'reactstrap';
import ReactTableBase from '../../../../../shared/components/table/ReactTableBase';
import ReactTableCustomizer from '../../../../../shared/components/table/components/ReactTableCustomizer';
//import ReactTableActions from './ReactTableActions';

const reorder = (rows, startIndex, endIndex) => {
  const result = Array.from(rows);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const defaultConfig = {
  watchCustomMenu: false,
  tableRowsData: false,
  withPagination: true,
  withSearchEngine: true,
  isSortable: false,
  watchCustomMenu: true
}

const no_op = () => { }
const DataReactTable = ({ title, reactTableData, config = defaultConfig, Callback, AddObservation, ReactTableActions, disabledTextFields, refresh = no_op, recalculateUnits = no_op, removeFormulaByIndex = no_op, dropFromTable = no_op, onUpdateFormula = no_op }) => {
  const [watchCustomMenu, setCustomMenu] = useState(config.watchCustomMenu);
  const [rows, setData] = useState(reactTableData.tableRowsData);
  const [isEditable, setIsEditable] = useState(config.isEditable);
  const [isResizable, setIsResizable] = useState(false);
  const [isSortable, setIsSortable] = useState(config.isSortable);
  const [isDisabledDragAndDrop, setIsDisabledDragAndDrop] = useState(false);
  const [isDisabledEditable, setIsDisabledEditable] = useState(false);
  const [isDisabledResizable, setIsDisabledResizable] = useState(false);
  const [withDragAndDrop, setWithDragAndDrop] = useState(false);
  const [withPagination, setWithPaginationTable] = useState(config.withPagination);
  const [withSearchEngine, setWithSearchEngine] = useState(config.withSearchEngine);

  const [skipPageReset, setSkipPageReset] = useState(false)

  useEffect(() => {
    refresh();
    setSkipPageReset(true);
  }, [reactTableData])


  const handleClickIsEditable = () => {
    if (!withDragAndDrop) setIsDisabledResizable(!isDisabledResizable);
    setIsResizable(false);
    setIsEditable(!isEditable);
  };
  const handleClickIsResizable = () => {
    setIsEditable(false);
    setWithDragAndDrop(false);
    setIsDisabledDragAndDrop(!isDisabledDragAndDrop);
    setIsDisabledEditable(!isDisabledEditable);
    setIsResizable(!isResizable);
  };
  const handleClickIsSortable = () => {
    setIsSortable(!isSortable);
  };
  const handleClickWithDragAndDrop = () => {
    if (!isEditable) setIsDisabledResizable(!isDisabledResizable);
    setIsResizable(false);
    setWithDragAndDrop(!withDragAndDrop);
  };
  const handleClickWithPagination = () => {
    setWithPaginationTable(!withPagination);
  };
  const handleClickWithSearchEngine = () => {
    setWithSearchEngine(!withSearchEngine);
  };

  const updateDraggableData = (result) => {
    const items = reorder(
      rows,
      result.source.index,
      result.destination.index,
    );
    setData(items);
  };

  const updateEditableData = (rowIndex, columnId, value) => {
    console.log('rowIndex', rowIndex, 'columnId', columnId, 'value', value);
    recalculateUnits(rowIndex, columnId, value);
    setData(old => old.map((item, index) => {
      if (index === rowIndex) {
        return {
          ...old[rowIndex],
          [columnId]: value,
        };
      }
      return item;
    }));
  };

  const tableConfig = {
    isEditable,
    isResizable,
    isSortable,
    withDragAndDrop,
    withPagination,
    withSearchEngine,
    manualPageSize: [5, 10, 20, 30],
    placeholder: 'Buscar',
    useActions: true,
    skipPageReset,
    actions: (data) => ReactTableActions({ data, Callback, AddObservation, disabledTextFields, removeFormulaByIndex, dropFromTable, onUpdateFormula })
  };

  return (
    <Col md={12} lg={12}>
      <div className="react-table__wrapper">
        <div className="card__title">
          <h5 className="bold-text">{title}</h5>
        </div>
        {watchCustomMenu ?
          <ReactTableCustomizer
            handleClickIsEditable={handleClickIsEditable}
            handleClickIsResizable={handleClickIsResizable}
            handleClickIsSortable={handleClickIsSortable}
            handleClickWithDragAndDrop={handleClickWithDragAndDrop}
            handleClickWithPagination={handleClickWithPagination}
            handleClickWithSearchEngine={handleClickWithSearchEngine}
            isEditable={isEditable}
            isResizable={isResizable}
            isSortable={isSortable}
            isDisabledDragAndDrop={isDisabledDragAndDrop}
            isDisabledEditable={isDisabledEditable}
            isDisabledResizable={isDisabledResizable}
            withDragAndDrop={withDragAndDrop}
            withPagination={withPagination}
            withSearchEngine={withSearchEngine}
            fullCustomizer
          /> : null}
      </div>
      <ReactTableBase
        key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
        columns={reactTableData.tableHeaderData}
        data={rows}
        refresh={refresh}
        updateEditableData={updateEditableData}
        updateDraggableData={updateDraggableData}
        /* isEditable={isEditable}
        handleClickIsEditable={handleClickIsEditable} */
        tableConfig={tableConfig}
      />
    </Col>
  );
};

DataReactTable.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default DataReactTable;
